const paymentSuccessStyles = {
  wrapper: {
    padding: '50px 20px 20px 20px',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: '15px',
  },
  base: {
    padding: 20,
    background: 'white',
    borderRadius: 5,
    boxShadow: '0 0 5px',
  },
  get success() {
    return { color: '#00ABDE', ...this.base }
  },
  get error() {
    return { color: 'orangered', ...this.base }
  },
}

export default paymentSuccessStyles



// WEBPACK FOOTER //
// ./src/components/common/credit/PaymentSuccess/styles.js